/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeterRouteCreate } from '../models/MeterRouteCreate';
import type { MeterRouteDetails } from '../models/MeterRouteDetails';
import type { MeterRouteUpdate } from '../models/MeterRouteUpdate';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class RoutesVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async routesVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/routes/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns MeterRouteDetails OK
     * @throws ApiError
     */
    public static async routesVGetExport(
        requestBody?: PagingQuery,
    ): Promise<MeterRouteDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/routes/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param meterRouteId
     * @returns MeterRouteDetails OK
     * @throws ApiError
     */
    public static async routesVGetById(
        meterRouteId: string,
    ): Promise<MeterRouteDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/routes/${meterRouteId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param meterRouteId
     * @param requestBody
     * @returns MeterRouteDetails OK
     * @throws ApiError
     */
    public static async routesVUpdate(
        meterRouteId: string,
        requestBody?: MeterRouteUpdate,
    ): Promise<MeterRouteDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/routes/${meterRouteId}`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param meterRouteId
     * @returns any No Content
     * @throws ApiError
     */
    public static async routesVDelete(
        meterRouteId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/routes/${meterRouteId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns MeterRouteDetails Created
     * @throws ApiError
     */
    public static async routesVCreate(
        requestBody?: MeterRouteCreate,
    ): Promise<MeterRouteDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/routes`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

}